import {baseApi} from "../baseApi";
import {
    IReconciliationBody,
    IReconciliationsResponse,
    IMonthReconciliationsResponse,
    IMonthDataBody,
    IMonthReconciliationsExcelResponse
} from "./types";
import {IAddressBody} from "../appointment_times/types";

const endpoints = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getReconciliations: builder.query<IReconciliationsResponse, number|null>({
            query: (addressId) => ({
                url: `api/adm/total-reconciliations/${addressId}`,
                method: 'GET',
            }),
            providesTags: ['reconciliations']

        }),
        getMonthReconciliations: builder.query<IMonthReconciliationsResponse, IMonthDataBody>({
            query: ({addressId, date, query, visit_date, page}) => ({
                url: `api/adm/total-reconciliations/${addressId}/month/${date}`,
                method: 'GET',
                params:{
                    query,
                    visit_date,
                    page
                }
            }),
            providesTags: ['reconciliations']

        }),
        getMonthReconciliationsExcel: builder.query<IMonthReconciliationsExcelResponse, IMonthDataBody>({
            query: ({addressId, date}) => ({
                url: `api/adm/total-reconciliations/${addressId}/month/${date}/export`,
                method: 'GET'
            }),
            providesTags: ['reconciliations']

        }),

    })
})

export const {
    useGetReconciliationsQuery, useLazyGetMonthReconciliationsQuery, useGetMonthReconciliationsExcelQuery
} = endpoints